import React from "react"
import { formatToCurrency } from "../../../helpers/FormatHelper";
import { useState } from "react";
import NumberInput from "../../shared/NumberInput";
import { searchOrdersNetting } from "../../../networking/NetworkingOrders";
import { useEffect } from "react";
import NettingViewOrder from "./NettingViewOrder";
import { use } from "react";

const  NettingInformationScreen = ({customerID, customerName, buyCurrency, selectedBuyCcy, onBackCurrency, onNextSummary}) => {

    const [ordersBuy, setOrdersBuy] = useState([]);
    const [ordersSell, setOrdersSell] = useState([]);
    const [orderBuySelections, setOrderBuySelections] = useState([]);
    const [orderSellSelections, setOrderSellSelections] = useState([]);
    const [balanceBuy, setBalanceBuy] = useState(0);
    const [balanceSell, setBalanceSell] = useState(0);

    const [orderID, setOrderID] = useState(0);
    const [showOrderDetail, setShowOrderDetail] = useState(false);

    const handleBuyCheckboxChange = (orderNo, amountToApply, checked) => {
    setOrderBuySelections(prev => {
        const updated = [...prev];
        const index = updated.findIndex(
            order => order.BNOrderNo === orderNo
        );

        if (index !== -1) {
            updated[index] = {
                ...updated[index],
                apply: checked,
                amountToApply: checked ? amountToApply : ''
            };
        }

        return updated;
    });
};

const handleSellCheckboxChange = (orderNo, amountToApply, checked) => {
    setOrderSellSelections(prev => {
        const updated = [...prev];
        const index = updated.findIndex(
            order => order.BNOrderNo === orderNo
        );

        if (index !== -1) {
            updated[index] = {
                ...updated[index],
                apply: checked,
                amountToApply: checked ? amountToApply : ''
            };
        }

        return updated;
    });
};

const handleBuyCheckboxBalanceChange = (orderNo, checked, amountToApply) => {
    setOrderBuySelections(prev => {
        const updated = prev.map(order => ({
            ...order,
            applyBalance: false
        }));

        const index = updated.findIndex(
            order => order.BNOrderNo === orderNo
        );

        if (index !== -1) {
            updated[index] = {
                ...updated[index],
                applyBalance: checked,
                apply: checked,
                amountToApply: checked ? amountToApply : ''
            };
        }

        return updated;
    });
};

const handleSellCheckboxBalanceChange = (orderNo, checked, amountToApply) => {
    setOrderSellSelections(prev => {
        const updated = prev.map(order => ({
            ...order,
            applyBalance: false
        }));

        const index = updated.findIndex(
            order => order.BNOrderNo === orderNo
        );

        if (index !== -1) {
            updated[index] = {
                ...updated[index],
                applyBalance: checked,
                apply: checked,
                amountToApply: checked ? amountToApply : ''
            };
        }

        return updated;
    });
};



const calculateNettingOrders = (buyOrders, sellOrders) => {
    const getAmount = order =>
        Number(order.TotalNetOrderNumber) || 0;

    const totalBuy = buyOrders.reduce(
        (sum, order) => sum + getAmount(order),
        0
    );

    const totalSell = sellOrders.reduce(
        (sum, order) => sum + getAmount(order),
        0
    );

    const initializeOrder = order => ({
        ...order,
        apply: false,
        applyBalance: false,
        amountToApply: ''
    });

    const buy = buyOrders.map(initializeOrder);
    const sell = sellOrders.map(initializeOrder);

    let balanceBuy = 0;
    let balanceSell = 0;

    const selectAll = orders =>
        orders.map(order => ({
            ...order,
            apply: true,
            amountToApply: getAmount(order)
        }));

    const selectUntilCovered = (orders, target) => {
        let remaining = target;

        const selected = orders.map(order => {
            const amount = getAmount(order);

            if (remaining <= 0) {
                return {
                    ...order,
                    apply: false,
                    applyBalance: false,
                    amountToApply: ''
                };
            }

            const amountToApply = Math.min(amount, remaining);
            remaining -= amountToApply;

            const hasBalance = amount > amountToApply;

            return {
                ...order,
                apply: true,
                applyBalance: hasBalance,
                amountToApply,
            };
        });

        const balance = selected.reduce(
            (sum, order) =>
                sum +
                (order.applyBalance
                    ? getAmount(order) - Number(order.amountToApply)
                    : 0),
            0
        );

        return { orders: selected, balance };
    };

    if (totalBuy > totalSell) {
        const result = selectUntilCovered(buy, totalSell);

        return {
            buy: result.orders,
            sell: selectAll(sell),
            balanceBuy: result.balance,
            balanceSell
        };
    }

    if (totalSell > totalBuy) {
        const result = selectUntilCovered(sell, totalBuy);

        return {
            buy: selectAll(buy),
            sell: result.orders,
            balanceBuy,
            balanceSell: result.balance
        };
    }

    return {
        buy: selectAll(buy),
        sell: selectAll(sell),
        balanceBuy,
        balanceSell
    };
};



const loadOrders = async () => {
    const response = await searchOrdersNetting({
        CustomerID: customerID,
        BuyCurrency: buyCurrency
    });

    if (!response?.bnorders) {
        setOrdersBuy([]);
        setOrdersSell([]);
        setOrderBuySelections([]);
        setOrderSellSelections([]);
        setBalanceBuy(0);
        setBalanceSell(0);
        return;
    }

    const buy = response.bnorders.filter(
        order => order.BuySell !== 'Sell'
    );

    const sell = response.bnorders.filter(
        order => order.BuySell === 'Sell'
    );

    const result = calculateNettingOrders(buy, sell);

    setOrdersBuy(buy);
    setOrdersSell(sell);
    setOrderBuySelections(result.buy);
    setOrderSellSelections(result.sell);
    setBalanceBuy(result.balanceBuy);
    setBalanceSell(result.balanceSell);
};


  useEffect(() => {
    loadOrders();
}, [customerID, buyCurrency]);
    
    
    const onClear = () => {
        onBackCurrency();
    }

    const onNew = () => {
       
    }

    const onNext = () => {
        onNextSummary(orderBuySelections, orderSellSelections, balanceBuy, balanceSell);
    }

    const totalBuyOriginal = ordersBuy.reduce(
        (total, order) => Number(total) + Number(order.TotalNetOrderNumber),
        0
    );

    const totalSellOriginal = ordersSell.reduce(
        (total, order) => Number(total) + Number(order.TotalNetOrderNumber),
        0
    );

    const totalBuyToApply = orderBuySelections.reduce(
        (total, order) =>
            total + (order.apply ? Number(order.amountToApply) : 0),
        0
    );

    const totalSellToApply = orderSellSelections.reduce(
        (total, order) =>
            total + (order.apply ? Number(order.amountToApply) : 0),
        0
    );

    const closeOrderDetail = () => {
        setShowOrderDetail(false);
        setOrderID(0);
    }

    const showDetail = (orderNo) => {
        setOrderID(orderNo);
        setShowOrderDetail(true);
    }

    
const getBuyOrdersList = () => {
    return (
        <table className="netting-table">
            <thead>
                <tr>
                    <th colSpan="2"></th>
                    <th>Total</th>
                    <th>{formatToCurrency(totalBuyOriginal)}</th>
                    <th>{formatToCurrency(totalBuyToApply)}</th>
                </tr>
                <tr>
                    <th>Apply<br />Balance</th>
                    <th>Apply</th>
                    <th>Order Id</th>
                    <th>Original<br />Amount</th>
                    <th colSpan="2">To Apply</th>
                </tr>
            </thead>

            <tbody>
                {orderBuySelections.map(order => {
                    const key = order.BNOrderNo;
                    const amountToApply = order.amountToApply ?? '';

                    return (
                        <tr key={key}>
                            <td className="checkbox-cell">
                                <input
                                    type="checkbox"
                                    checked={order.applyBalance || false}
                                    onChange={e =>
                                        handleBuyCheckboxBalanceChange(
                                            key,
                                            e.target.checked,
                                            order.TotalNetOrderNumber
                                        )
                                    }
                                    disabled={true}
                                />
                            </td>

                            <td className="checkbox-cell">
                                <input
                                    type="checkbox"
                                    checked={order.apply || false}
                                    onChange={e =>
                                        handleBuyCheckboxChange(
                                            key,
                                            order.TotalNetOrderNumber,
                                            e.target.checked
                                        )
                                    }
                                    disabled={true}
                                />
                            </td>

                            <td>
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        showDetail(key);
                                    }}
                                >
                                    {key}
                                </a>
                            </td>

                            <td className="amount">
                                {formatToCurrency(order.TotalNetOrderNumber)}
                            </td>

                            <td className="amount">
                                <NumberInput
                                    id={`txt-buyapplyamount-${key}`}
                                    key={`txt-buyapplyamount-${key}`}
                                    className="amount-input"
                                    value={amountToApply}
                                    disabled={true}
                                    scale={2}
                                    type="Currency"
                                />
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};


    
const getSellOrdersList = () => {
    return (
        <table className="netting-table">
            <thead>
                <tr>
                    <th colSpan="2"></th>
                    <th>Total</th>
                    <th>{formatToCurrency(totalSellOriginal)}</th>
                    <th>{formatToCurrency(totalSellToApply)}</th>
                </tr>
                <tr>
                    <th>Apply<br />Balance</th>
                    <th>Apply</th>
                    <th>Order Id</th>
                    <th>Original<br />Amount</th>
                    <th>To Apply</th>
                </tr>
            </thead>

            <tbody>
                {orderSellSelections.map(order => {
                    const key = order.BNOrderNo;
                    const amountToApply = order.amountToApply ?? '';

                    return (
                        <tr key={key}>
                            <td className="checkbox-cell">
                                <input
                                    type="checkbox"
                                    checked={order.applyBalance || false}
                                    onChange={e =>
                                        handleSellCheckboxBalanceChange(
                                            key,
                                            e.target.checked,
                                            order.TotalNetOrderNumber
                                        )
                                    }
                                    disabled={true}
                                />
                            </td>

                            <td className="checkbox-cell">
                                <input
                                    type="checkbox"
                                    checked={order.apply || false}
                                    onChange={e =>
                                        handleSellCheckboxChange(
                                            key,
                                            order.TotalNetOrderNumber,
                                            e.target.checked
                                        )
                                    }
                                    disabled={true}
                                />
                            </td>

                            <td>
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        showDetail(key);
                                    }}
                                >
                                    {key}
                                </a>
                            </td>

                            <td className="amount">
                                {formatToCurrency(order.TotalNetOrderNumber)}
                            </td>

                            <td className="amount">
                                <NumberInput
                                    id={`txt-sellapplyamount-${key}`}
                                    key={`txt-sellapplyamount-${key}`}
                                    className="amount-input"
                                    value={amountToApply}
                                    disabled={true}
                                    scale={2}
                                    type="Currency"
                                />
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};


    return (
        <div className="uk-grid">
            <div  className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{'Customer:'}</label>
                <input className="uk-input" id="customer-name" value={customerName} type="text" disabled={true} />
            </div>
            <div  className="uk-width-1-4 uk-form-controls">
                <label className="uk-form-label">{'Settlement Currency:'}</label>
                <input className="uk-input" id="ccy-name" value={selectedBuyCcy} type="text" disabled={true} />            
            </div>
            

            <div  className="uk-width-1-1 uk-form-controls" style={{marginTop:'20px'}}>
                <div className="uk-grid">
                    <div className="uk-width-1-2">
                        <div  className="uk-grid">
                            <div className="uk-width-1-2">
                                <h5>{`Our Buy Orders `}</h5> 
                            </div>
                            <div className="uk-width-1-2" style={{paddingRight:'10%',textAlign:'right'}}>
                                {balanceBuy !== 0 && (
                                    <h6>Balance: {formatToCurrency(balanceBuy)}</h6>
                                )}
                            </div>
                        </div>
                        
                        {getBuyOrdersList()}
                        
                    </div>
                    <div className="uk-width-1-2">
                        <div  className="uk-grid">
                            <div className="uk-width-1-2">
                                <h5>{`Customer Orders `}</h5> 
                            </div>
                            <div className="uk-width-1-2" style={{paddingRight:'10%',textAlign:'right'}}>
                                {balanceSell !== 0 && (
                                    <h6>Balance: {formatToCurrency(balanceSell)}</h6>
                                )}
                            </div>
                        </div>
                        
                        {getSellOrdersList()}
                    </div>
                </div>
            </div>

            <div  className="uk-width-1-1 uk-form-controls" style={{marginTop:'20px'}}>
               
                <button className="uk-button uk-button-green" onClick={onClear}>
                    {'Exit'}
                </button>
                <button className="uk-button uk-button-green" onClick={onNext}>
                    {'Next'}
                </button>
            </div>
            <NettingViewOrder orderID={orderID} showOrder={showOrderDetail} onCloseOrderDetail={closeOrderDetail}/>
        </div>
    );
}

export default NettingInformationScreen;